import React from 'react'
import styles from './Weekofoffersection.module.scss'
import Link from 'next/link'

// const Watchimage = '/assets/accessories/watch.png'
// const SaleTicketImage = '/assets/accessories/saleticketimage.png'
const menfashion = '/assets/img/menfashion.png'
const menvision = '/assets/img/menvision.png'

export default function Weekofoffersection() {
  return (
    <div>
      <div className={styles.WeekofoffersectionMain}>
        {/* <div className={styles.Weekofoffersectionfirst}>
          <div className={styles.Watchimage}>
            <img src={Watchimage} alt="Watchimage" />
          </div>
          <div className={styles.SaleTicketImage}>
            <img src={SaleTicketImage} alt="SaleTicketImage" />
          </div>
          <div className={styles.timelesscontentmain}>
            <h1>Timeless elegance for the modern era</h1>
            <button>
              <span>Shop Now</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1.49953 8.00011C1.49953 7.65511 1.77953 7.37511 2.12453 7.37511L12.393 7.37511L8.67703 3.56111C8.61723 3.50289 8.56969 3.43328 8.53723 3.35638C8.50476 3.27949 8.48803 3.19687 8.48801 3.11341C8.48799 3.02994 8.50469 2.94731 8.53713 2.87041C8.56956 2.7935 8.61707 2.72387 8.67686 2.66563C8.73664 2.60738 8.80748 2.5617 8.88521 2.53127C8.96293 2.50085 9.04596 2.48631 9.1294 2.4885C9.21284 2.49069 9.29499 2.50956 9.37101 2.54402C9.44704 2.57848 9.51539 2.62781 9.57203 2.68911L14.3205 7.56261C14.4355 7.67919 14.5 7.83636 14.5 8.00011C14.5 8.16386 14.4355 8.32103 14.3205 8.43761L9.57203 13.3111C9.51539 13.3724 9.44704 13.4217 9.37101 13.4562C9.29499 13.4907 9.21284 13.5095 9.1294 13.5117C9.04596 13.5139 8.96293 13.4994 8.88521 13.4689C8.80748 13.4385 8.73664 13.3928 8.67686 13.3346C8.61707 13.2763 8.56956 13.2067 8.53713 13.1298C8.50469 13.0529 8.48799 12.9703 8.48801 12.8868C8.48803 12.8033 8.50476 12.7207 8.53723 12.6438C8.56969 12.5669 8.61723 12.4973 8.67703 12.4391L12.393 8.62511L2.12453 8.62511C1.77953 8.62511 1.49953 8.34511 1.49953 8.00011Z"
                  fill="#4C515D"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className={styles.Weekofoffersectionfirst}>
          <div className={styles.Watchimage}>
            <img src={Watchimage} alt="Watchimage" />
          </div>
          <div className={styles.SaleTicketImage}>
            <img src={SaleTicketImage} alt="SaleTicketImage" />
          </div>
          <div className={styles.timelesscontentmain}>
            <h1>Timeless elegance for the modern era</h1>
            <button>
              <span>Shop Now</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1.49953 8.00011C1.49953 7.65511 1.77953 7.37511 2.12453 7.37511L12.393 7.37511L8.67703 3.56111C8.61723 3.50289 8.56969 3.43328 8.53723 3.35638C8.50476 3.27949 8.48803 3.19687 8.48801 3.11341C8.48799 3.02994 8.50469 2.94731 8.53713 2.87041C8.56956 2.7935 8.61707 2.72387 8.67686 2.66563C8.73664 2.60738 8.80748 2.5617 8.88521 2.53127C8.96293 2.50085 9.04596 2.48631 9.1294 2.4885C9.21284 2.49069 9.29499 2.50956 9.37101 2.54402C9.44704 2.57848 9.51539 2.62781 9.57203 2.68911L14.3205 7.56261C14.4355 7.67919 14.5 7.83636 14.5 8.00011C14.5 8.16386 14.4355 8.32103 14.3205 8.43761L9.57203 13.3111C9.51539 13.3724 9.44704 13.4217 9.37101 13.4562C9.29499 13.4907 9.21284 13.5095 9.1294 13.5117C9.04596 13.5139 8.96293 13.4994 8.88521 13.4689C8.80748 13.4385 8.73664 13.3928 8.67686 13.3346C8.61707 13.2763 8.56956 13.2067 8.53713 13.1298C8.50469 13.0529 8.48799 12.9703 8.48801 12.8868C8.48803 12.8033 8.50476 12.7207 8.53723 12.6438C8.56969 12.5669 8.61723 12.4973 8.67703 12.4391L12.393 8.62511L2.12453 8.62511C1.77953 8.62511 1.49953 8.34511 1.49953 8.00011Z"
                  fill="#4C515D"
                />
              </svg>
            </button>
          </div>
        </div> */}
        <Link href="/search/?q=backpack&type=product">
          <img src={menfashion} alt="menfashion" />
        </Link>
        <Link href="/store/biscayners/">
          <img src={menvision} alt="menvision" />
        </Link>
      </div>
    </div>
  )
}
